import { Directive, HostBinding, OnInit, inject } from '@angular/core';
import { BuilderInfoService } from '../shared';

@Directive({
  selector: '[portalDirection]',
  standalone: false,
})
export class DirectionDirective implements OnInit {
  private readonly builderInfoService = inject(BuilderInfoService);

  isRtl = false;

  @HostBinding('class.rtl')
  get rtl(): boolean {
    return this.isRtl;
  }

  ngOnInit(): void {
    this.isRtl = this.builderInfoService.interfaceDirection === 'rtl';
  }
}
